<template>
  <FullScreenPopup
    class="full-screen-popup"
    ref="popup"
    :title="notification.title"
    :lock-scroll="false"
  >
    <div class="notification-message-popup-wrapper">
      <MarkupMessage :text="notification.message" />

      <div class="notification-message-popup__controls-wrapper">
        <Divider type="horizontal" />
        <div class="notification-message-popup__controls">
          <BlueButton
            class="notification-message-popup__button"
            size="small"
            @click="close"
          >
            Ok
          </BlueButton>
        </div>
      </div>
    </div>
  </FullScreenPopup>
</template>

<script>
import { Divider } from '@/shared/ui/divider';
import { BlueButton } from '@/shared/ui/form';
import { MarkupMessage } from '@/shared/ui/markup-message';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  data() {
    return {
      notification: {
        title: '',
        message: '',
        date: null,
      },
    };
  },
  components: { BlueButton, Divider, FullScreenPopup, MarkupMessage },
  methods: {
    open(notification) {
      this.notification = {
        title: notification.title || '',
        message: notification.message || '',
        date: notification.created_at || null,
      };
      this.$refs.popup.open();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    close() {
      this.$refs.popup.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-message-popup {
  &-wrapper {
    max-width: 600px;
  }

  &__controls {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 550px) {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 550px) {
    &__button {
      margin-bottom: 8px;
    }
  }
}

::v-deep .popup-title {
  max-width: 600px;
}
</style>
